import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/ChatOnboarding/GiftSetGoalPaywall/giftSetGoalPaywallCopy";

const I18n = I18nUtil.createScoped(Translations);

/** Gift Set Goal Paywall 文案（Figma `96097:351742`） */
export type GiftSetGoalPaywallCopy = {
  beforeYouGo: string;
  takeYourPlanFree: string;
  headline: string;
  features: readonly string[];
  unlockCta: string;
  disclaimer: string;
};

/**
 * Gift Set Goal Paywall 文案，调用时解析（便于后续接入 i18n / locale）。
 *
 * 待补 translate key（勿改 `src/translate/`，由 i18n 流程维护）：
 * - Before you go
 * - Take your plan, free.
 * - Ed picked you for a one-time free plan setup.
 * - See your full plan — all 5 moves
 * - Your real numbers, mapped in 2 minutes
 * - Built around your goals — yours to keep
 * - Build my plan free
 * - Activating live tracking is Pro — start whenever you're ready.
 */
export function getGiftSetGoalPaywallCopy(): GiftSetGoalPaywallCopy {
  return {
    beforeYouGo: I18n.t("Before you go"),
    takeYourPlanFree: I18n.t("Take your plan, free."),
    headline: I18n.t("Ed picked you for a one-time free plan setup."),
    features: [
      I18n.t("See your full plan — all 5 moves"),
      I18n.t("Your real numbers, mapped in 2 minutes"),
      I18n.t("Built around your goals — yours to keep"),
    ],
    unlockCta: I18n.t("Build my plan free"),
    disclaimer: I18n.t(
      "Activating live tracking is Pro — start whenever you're ready.",
    ),
  };
}
